import React from 'react';
import InputDateTime from "../../../../components/input/input-datetime.jsx";
import InputRadio from "../../../../components/input/input-radio.jsx";
import InputCheckbox from "../../../../components/input/input-checkbox.jsx";
import {minMenuHeight} from "../../../../components/reports/report-menu/menu.jsx";

const Filters = ({ setFilters, filters }) => {

    return (
        <>
            <div className={`mb-2 ${minMenuHeight}`}>
                <form className={'space-y-4'}>

                    <InputDateTime
                        id="dtStart"
                        label="Data/hora inicial *"
                        selected={filters.dtStart}
                        onChange={(date) => setFilters(prev => ({ ...prev, dtStart: date }))}
                        classNameWrapper={"w-full"}
                        dateFormat="LL"
                    />

                    <InputDateTime
                        id="dtEnd"
                        label="Data/hora final *"
                        selected={filters.dtEnd}
                        onChange={(date) => setFilters(prev => ({ ...prev, dtEnd: date }))}
                        classNameWrapper={"w-full"}
                        dateFormat="LL"
                    />

                    <InputCheckbox
                        id="showLayer"
                        label="Exibir setor"
                        className="ml-1"
                        checked={!!filters.showLayer}
                        value={filters.showLayer}
                        onChange={() => setFilters(prev => ({...prev, showLayer: !prev.showLayer}))}
                    />

                <hr className={"filter-divisor !mb-3"}/>

                    <span className={'ml-1 text-[12px] text-left'}> Formato: </span>
                    <InputRadio
                        name="map-mode"
                        id="search-type-routes"
                        label="Rota"
                        className="ml-1 mb-3 mt-3"
                        value="routes-mode"
                        checked={filters.mapMode === 'routes-mode'}
                        onChange={(e) => setFilters(prev => ({...prev, mapMode: e.target.value}))}
                    />

                    <InputRadio
                        name="map-mode"
                        id="search-type-heatmap"
                        label="Mapa de calor"
                        className="ml-1 mb-3"
                        value="heatmap-mode"
                        checked={filters.mapMode === 'heatmap-mode'}
                        onChange={(e) => setFilters(prev => ({...prev, mapMode: e.target.value}))}
                    />

                    <InputRadio
                        name="map-mode"
                        id="search-type-detail"
                        label="Detalhes da rota"
                        className="ml-1"
                        value="detail-mode"
                        checked={filters.mapMode === 'detail-mode'}
                        onChange={(e) => setFilters(prev => ({...prev, mapMode: e.target.value}))}
                    />

                </form>
            </div>
        </>
    );
};

export default Filters;